import React from "react";
import { motion } from "framer-motion";
import { fadeIn, zoomIn } from "../components/motionUtils";
import { Education } from "../components/Education";
import { Experience } from "../components/Experience";
import { Navigation } from "../components/Navigation";
import { Projects } from "../components/Projects";
import { Skills } from "../components/Skills";
import { resume } from "../data/resume";

// exporting unit test-id for Jest Testing Library
export const NAME_TEST_ID = "NAME_TEST_ID";
export const SCROLL_TO_TOP_TEST_ID = "SCROLL_TO_TOP_TEST_ID";
export const CONTACT_TEST_ID = "CONTACT_TEST_ID";
export const EXPERIENCE_TEST_ID = "EXPERIENCE_TEST_ID";
export const SKILLS_TEST_ID = "SKILLS_TEST_ID";

export const Home = () => {
  return (
    <div className="flex flex-col gap-1 px-4 pb-2 md:px-16 lg:px-60 md:pb-8 bg-whiteBackground w-full h-full font-poppins">
      <div className="w-full flex flex-col-reverse items-center justify-center sticky top-0 left-0 right-0 z-50 bg-whiteBackground py-2 md:py-8">
        <Navigation />
      </div>
      <div className="flex flex-col gap-16 py-10 sm:py-40 md:py-10 bg-whiteBackground w-full">
        <div className="flex flex-row items-center justify-between w-full">
          <div
            data-testid={NAME_TEST_ID}
            className="font-thin text-xs flex flex-col space-y-3 w-3/5 sm:w-3/4"
          >
            <motion.div
              variants={zoomIn(0, 1)}
              whileInView="show"
              initial="hidden"
              viewport={{ once: false, amount: 0.25 }}
              className="w-full"
            >
              <h1 className="font-lora text-2xl sm:text-6xl">{resume.name}</h1>
              <p className="font-semibold sm:text-xl">
                <b>{resume.role}</b>
              </p>
            </motion.div>
          </div>
          <div className="font-thin text-[0.6rem] sm:text-base w-2/5 sm:w-1/4">
            <motion.div
              data-testid={CONTACT_TEST_ID}
              variants={zoomIn(0, 2)}
              whileInView="show"
              initial="hidden"
              viewport={{ once: false, amount: 0.25 }}
              className="w-full"
            >
              <p>Contact Information:</p>
              <p className="font-semibold">{resume.phone}</p>
              <div className="flex flex-row items-center gap-1">
                <span className="relative flex h-3 w-3">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-amber-400 opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-3 w-3 bg-[#ffa500]"></span>
                </span>
                <a
                  className="text-sky-500 font-semibold cursor-pointer"
                  href={`mailto: ${resume.email}`}
                >
                  E-mail me
                </a>
              </div>
            </motion.div>
          </div>
        </div>
        <div className="flex sm:flex-row flex-col-reverse items-start justify-start w-full text-grayDark">
          <div
            data-testid={EXPERIENCE_TEST_ID}
            className="flex flex-col w-full sm:w-3/4 sm:pr-4"
          >
            <h1 className="text-sky-500 font-semibold text-sm sm:text-xl">
              EXPERIENCES
            </h1>
            <br />
            <Experience />
            <h1 className="text-sky-500 font-semibold text-sm sm:text-xl">
              EDUCATION
            </h1>
            <br />
            <motion.div
              variants={fadeIn("right", "tween", 0, 1.5)}
              whileInView="show"
              initial="hidden"
              viewport={{ once: false, amount: 0.05 }}
              className="w-full"
            >
              <Education />
            </motion.div>
            {/* <h1 className="text-sky-500 font-semibold text-sm sm:text-xl">
              PROJECTS
            </h1> */}
            <br />
            <Projects />
          </div>
          <div
            data-testid={SKILLS_TEST_ID}
            className="flex flex-col w-full sm:w-1/4"
          >
            <h1 className="text-sky-500 font-semibold text-sm sm:text-xl">
              SKILLS
            </h1>
            <br />
            <Skills />
            <h1 className="text-sky-500 font-semibold text-sm sm:text-xl">
              LANGUAGES
            </h1>
            <br />
            {resume.languages.map((language, index) => {
              return (
                <motion.div
                  variants={fadeIn("right", "tween", 0, 1.5)}
                  whileInView="show"
                  initial="hidden"
                  viewport={{ once: false, amount: 0.05 }}
                  className="w-full"
                  key={index}
                >
                  <h1 className="font-lora text-sm sm:text-base py-1">
                    <span className="font-semibold">{language.name}</span> -
                    <span>
                      <i>{language.level}</i>
                    </span>
                  </h1>
                </motion.div>
              );
            })}
            <br />
            <br />
          </div>
        </div>
      </div>
      <div
        data-testid={SCROLL_TO_TOP_TEST_ID}
        className="h-14 w-14 rounded-[50%] bg-white shadow-lg border-0 text-darkBlack font-extrabold text-xl flex flex-row items-center justify-center animate-[bounce_1.5s_infinite_100ms] cursor-pointer"
        onClick={() => window.scrollTo({ top: 0, left: 0, behavior: "smooth" })}
      >
        ↑
      </div>
    </div>
  );
};
